import type { Team } from '../../api/teams'

/** Rolling-deployment safe: missing metadata is the existing prepaid mode. */
export function isPostpaidTeam(team: Team | null | undefined): boolean {
  return team?.creditBillingMode === 'postpaid'
}

export function canViewPostpaidUsage(team: Team | null | undefined): boolean {
  return isPostpaidTeam(team) && (team?.myRole === 'owner' || team?.myRole === 'admin')
}
